import React, { useMemo } from "react";
import { Divider, Row, Col, Form, Checkbox, Button, Popconfirm } from "antd";
import { ShipmentStatus } from "@/utils/enum";

export default function ShipmentActions({
  shipment,
  formRef,
  configPerm,
  openUserModal,
  postShipmentButtonDisabled,
  toggleDispatchModal,
  assignShipmentButtonDisabled,
}) {
  const renderButtonList = useMemo(() => {
    const buttonList = [];

    if (shipment.status === ShipmentStatus.Completed && configPerm["CoreService.AdminShipments.Post"]) {
      buttonList.push(
        <Button
          key="post-shipment"
          type="primary"
          htmlType="submit"
          disabled={postShipmentButtonDisabled}
          onClick={() => openUserModal()}
        >
          Post Shipment
        </Button>,
      );
    }

    if (shipment.status === ShipmentStatus.Completed && configPerm["CoreService.AdminShipments.Accept"]) {
      buttonList.push(
        <Button
          key="post-and-assign-shipment"
          type="primary"
          htmlType="submit"
          onClick={() => toggleDispatchModal()}
          disabled={postShipmentButtonDisabled}
        >
          Post and Assign Shipment
        </Button>,
      );
    }

    if (shipment.status === ShipmentStatus.Posted && configPerm["CoreService.AdminShipments.Accept"]) {
      buttonList.push(
        <Button
          key="assign-shipment"
          type="primary"
          htmlType="submit"
          onClick={() => toggleDispatchModal()}
          disabled={assignShipmentButtonDisabled}
        >
          Assign Shipment
        </Button>,
      );
    }

    return buttonList;
  }, [
    shipment?.status,
    postShipmentButtonDisabled,
    assignShipmentButtonDisabled,
    configPerm,
    openUserModal,
    toggleDispatchModal,
  ]);

  if (![ShipmentStatus.Completed, ShipmentStatus.Posted].includes(shipment.status)) {
    return null;
  }

  return (
    <>
      <Divider />
      <Row justify="end">
        <Col col={24}>
          <Form ref={formRef}>
            <Form.Item>
              <section
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "flex-end",
                }}
              >
                {renderButtonList}
              </section>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  );
}
